<template>
	<div class="opera-aversion" >
    <topNav title="版本信息" url='/opera/center' replace="true"></topNav>
		<div class="title"  @click="goDetail">
            <img :src="iconUrl" v-if="iconUrl">
			<h2>版本号：{{version}}</h2>
		</div>
		<div class="infoList" @click="goDetail">
			<ul class="tip">
				<li>1、全新界面风格，采用类支付宝App首页的可定义功能按钮。
					<div class="pic"><img src='../../assets/images/homeSnap.png'></div>
				</li>
				<li>2、增加消息模块，第一时间接收到有用的通知。.</li>
				<li>3、增加事件预警、对酒店关键指标可预警提醒。</li>
			</ul>
            <div class="ver" v-if="disVersion">
                <img src="../../assets/images/newLogo.png">
                <div>&copy; 2014-2025 ihotel.cn. All rights reserved.</div>
            </div>
		</div>
	</div>
</template>
<script>
export default {
  data() {
    return {
      version: "",
      disVersion: false,
      iconUrl:""
    };
  },
  mounted() {
    this.version = this.pversion;
    this.disVersion = this.$isMihotel;
    if (!this.disVersion) {
      this.iconUrl = "./static/images/" + this.$logo;
    } else {
      this.iconUrl = "./static/images/icon.png";
    }
  },
  methods: {
    goDetail() {
      this.$router.push({ path: "/opera/versionDetail" });
    }
  },
  filters: {},
  components: {}
};
</script>
<style lang='less'>
.opera-aversion {
  .title {
    text-align: center;
    margin-top: 10px;
    h1 {
      margin: 20px auto 5px;
      font-size: 0.5rem;
    }
    h2 {
      font-size: 0.3rem;
      font-weight: normal;
      margin-top: 0;
      color: #999;
    }
    img {
      width: 54px;
      margin: 0 auto 5px;
    }
  }
  .tip {
    margin: 0 auto;
    width: 90%;
  }
  .tip li {
    line-height: 0.5rem;
    margin-top: 5px;
  }
  .tip .pic img {
    width: 80%;
    margin: 0 auto;
  }
  .ver {
    position: fixed;
    bottom: 10px;
    left: 0;
    width: 100%;
    text-align: center;
    img {
      width: 65px;
      height: 22px;
      margin: 0 auto;
    }
    div {
      font-size: 9px;
      color: #d7d7d7;
      margin-top: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// version.vue?019943f4